import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IsAdmin } from '../../guards/isAdmin';
import { Message, ConfirmationService } from 'primeng/api';
// https://stackoverflow.com/questions/34660265/importing-lodash-into-angular2-typescript-application
import * as _ from 'lodash';
import { TrainingSession, TrainingSessionService, ITrainingSession } from '../../services/GI.Web.Services.g';
import { ErrorHandling } from '../../ErrorHandling';

@Component({
  selector: 'app-training-sessions-list',
  templateUrl: './training-sessions-list.component.html',
  styleUrls: ['./training-sessions-list.component.css']
})
export class TrainingSessionsListComponent implements OnInit {
  constructor(
    private trainingSessionService: TrainingSessionService,
    private router: Router,
    private adminGuard: IsAdmin,
    private confirmationService: ConfirmationService
  ) { }

  public trainingSessions: ITrainingSession[] = [];
  public trainingSessionsReady = false;
  public cols: any[] = [];
  public globalFilterFields: any[] = [];
  public messages: Message[] = [];
  public canEmailStudents = true;

  async ngOnInit() {
    this.adminGuard.canActivate();
    await this.getTrainingSessions();
    this.setColumns();
  }

  async getTrainingSessions() {
    try {
      this.trainingSessions = await this.trainingSessionService.getAll().toPromise();
    } catch (error) {
      this.messages = ErrorHandling.getErrorMessages(error, 'Could not get Training Sessions');
    }
    this.trainingSessionsReady = true;
  }

  setColumns() {
    this.cols = [
      { field: 'eventName', header: 'Event', sortable: true, inGlobalFilter: true },
      { field: 'courseName', header: 'Course', sortable: true, inGlobalFilter: true },
      { field: 'startDate', header: 'Start', sortable: true, inGlobalFilter: false },
      { field: 'endDate', header: 'End', sortable: true, inGlobalFilter: false },
      { field: 'enableCloudResources', header: 'Cloud', sortable: true, inGlobalFilter: false },
      // { field: 'deploymentStatus', header: 'Cloud Status', sortable: true, inGlobalFilter: true },
      { field: '', header: 'Actions', sortable: false, inGlobalFilter: false }
    ];
    this.cols.forEach(c => {
      if (c.inGlobalFilter) {
        this.globalFilterFields.push(c.field);
      }
    });
  }

  navigateToDetail(id: string) {
    this.router.navigate(['/trainingsession/' + encodeURIComponent(id)]);
  }

  addTrainingSession() {
    this.router.navigate(['/trainingsession/new']);
  }

  confirmDelete(session: TrainingSession) {
    this.confirmationService.confirm({
      message: `Are you sure you want to permanently delete the Training Session '${session.eventName}'?`,
      accept: () => this.delete(session)
    });
  }

  async delete(session: TrainingSession) {
    try {
      await this.trainingSessionService.delete(session.id).toPromise();
      // After successfully deleted on server, remove from local list
      _.remove(this.trainingSessions, session);
    } catch (error) {
      this.messages = ErrorHandling.getErrorMessages(error);
    }
  }

  confirmEmailAllStudents(session: ITrainingSession) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to Email ALL students?',
      accept: () => {
        this.emailStudents(session);
      }
    });
  }

  public async emailStudents(session: ITrainingSession): Promise<void> {
    this.canEmailStudents = false;
    try {
      await this.trainingSessionService.mailAll(session.id).toPromise();
    } catch (error) {
      this.messages = ErrorHandling.getErrorMessages(error, 'Failed to email all students:');
    }
    this.canEmailStudents = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/training-sessions-list/training-sessions-list.component.ts